import { compose, hoistStatics, withState, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';


import ImageModal from './ImageModal';
import flh from '../../../helpers/file.helper';

const alertImg = '/img/alert.svg';

const onImageError = props => (e) => {
  const { setErrorImg } = props;
  setErrorImg(true);
  e.target.src = alertImg;
};

const createMainScr = (props) => {
  const isFileUrl = props.file && props.file.url;
  const mainScr = isFileUrl ? props.file.url : flh.createLink(props.file.id, props.token);
  return mainScr;
};

const mapStateToProps = state => ({
  token: state.auth.token,
});

const enhance = compose(
  translate('portal'),
  connect(mapStateToProps, null),
  withState('errorImg', 'setErrorImg', false),
  withProps(props => ({
    downloadLink: props.file ? flh.createDownloadLink(props.file.id, props.token) : '#',
    mainScr: createMainScr(props),
  })),
  withHandlers({
    onImageError,
  }),
);

export default hoistStatics(enhance)(ImageModal);



// WEBPACK FOOTER //
// ./src/components/modalWindows/imageModal/index.js